// extracted by mini-css-extract-plugin
export default {"list":"egwuO","button":"ftdEe"};